import Link from './Link'

export default Link
// eslint-disable-next-line import/export
export * from './Link'
